package com.bikompanion.ui.home

import com.bikompanion.domain.BikeStation

internal data class StationFocusResolution(
    val target: StationFocusTarget,
    val station: BikeStation,
    val zoom: Double,
)
